module.exports = __webpack_public_path__ + "img/shake_shack.b131ede4.svg";